const Preloder = () => {
	return (
		<div className="preloader">
			<div className="preloader-inner">
				<div className="preloader-icon">
					<span></span>
					<span></span>
				</div>
			</div>
		</div>
	)
}

export default Preloder
